import React from 'react';
import _ from 'lodash';
import LoadImage from '../../common/images/LoadImage';

const getUrl = (
  images,
  profileOnly,
  exteriorIndex,
  interiorIndex,
  switchThumbnail
) => {
  const exteriorUrl = _.get(images.exterior[exteriorIndex], 'url');
  const interiorUrl = _.get(images.interior[interiorIndex], 'url');
  const profileUrl = _.get(_.find(images.exterior, 'profile'), 'url');

  if (profileOnly) {
    return profileUrl;
  }
  if (switchThumbnail) {
    return interiorUrl;
  }
  return exteriorUrl;
};

const PriceSummaryThumbnail = props => {
  const {
    images,
    interiorIndex,
    exteriorIndex,
    switchThumbnail,
    profileOnly,
    displayThumbnail
  } = props;

  if (!displayThumbnail) {
    return null;
  }

  const url = getUrl(
    images,
    profileOnly,
    exteriorIndex,
    interiorIndex,
    switchThumbnail
  );

  return (
    <div
      className="price-summary-thumbnail hide-for-large"
      id="price-summary-thumbnail">
      <LoadImage url={url}>
        {({ isLoading }) =>
          isLoading ? (
            <div className="loader price-summary-thumbnail__loader" />
          ) : (
            <div
              className="price-summary-thumbnail__image"
              style={{ backgroundImage: `url(${url})` }}
            />
          )
        }
      </LoadImage>
    </div>
  );
};

export default PriceSummaryThumbnail;
